import styled from 'styled-components/macro'

const AdditionalInfo = styled('div')`
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;

  p {
    color: rgba(0, 0, 0, 0.87);
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.01071em;
  }
`

export default AdditionalInfo
